import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

@Injectable()
export class ConferenceToolService {
  constructor(private configService: ConfigService,
    private requestService: RequestService) {
  }

  saveTokenZoom(params: { code: string, redirectUri: string }): Observable<any> {
    const url = this.configService.get('server').url + this.configService.get('endpoints').solar.courseEvent.saveTokenZoom.api
      + `?code=${params.code}&redirectUri=${params.redirectUri}`;
    return this.requestService.post(url, {});
  }
  checkIfUserIsInAccount(meetingType: string, username: string): Observable<{ data: boolean }> {
    const url = this.configService.get('server').url + this.configService.get('endpoints').solar.courseEvent.checkIfUserInAccount.api
      + '?meetingType=' + meetingType
      + '&userName=' + encodeURIComponent(username);

    return this.requestService.get(url);
  }

  checkIfAccountIsPro(meetingType: string): Observable<{ data: boolean }> {
    const url = this.configService.get('server').url + this.configService.get('endpoints').solar.courseEvent.checkIfAccountIsPro.api
      + '?meetingType=' + meetingType;

    return this.requestService.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/conference-tool.service.ts